import { main } from './main/index.js'

main().then(app => app.mount('#app'))
